import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from "@/views/new/Index.vue";
import About from "@/views/new/About.vue";

import DeepSeek from "@/views/new/products/deepseek.vue";
import Agent from "@/views/new/products/agent.vue";
import PC from "@/views/new/products/pc.vue";
import GenAI from "@/views/new/products/genai.vue";
import DataService1 from "@/views/new/products/data-service1.vue";
import DataService2 from "@/views/new/products/data-service2.vue";
import DataService3 from "@/views/new/products/data-service3.vue";
import CloudService from "@/views/new/products/cloud-service.vue";


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            title: '首頁 | BOATWATER',
        },
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '關於我們 | BOATWATER',
        },
    },
    {
        path: '/agent',
        name: 'Agent',
        component: Agent,
        meta: {
            title: '企業級Agent中台 | BOATWATER',
        },
    },
    {
        path: '/deep-seek',
        name: 'DeepSeek',
        component: DeepSeek,
        meta: {
            title: 'DeepSeek企業版 | BOATWATER',
        },
    },
    {
        path: '/pc',
        name: 'PC',
        component: PC,
        meta: {
            title: 'PC本地部署大模型 | BOATWATER',
        },
    },
    {
        path: '/gen-ai',
        name: 'GenAI',
        component: GenAI,
        meta: {
            title: '企業級一站式GenAI平台 | BOATWATER',
        },
    },
    {
        path: '/data-service1',
        name: 'DataService1',
        component: DataService1,
        meta: {
            title: '數據安全管控平台 | BOATWATER',
        },
    },
    {
        path: '/data-service2',
        name: 'DataService2',
        component: DataService2,
        meta: {
            title: '數據治理諮詢與實施服務 | BOATWATER',
        },
    },
    {
        path: '/data-service3',
        name: 'DataService3',
        component: DataService3,
        meta: {
            title: '數字化應用開發 | BOATWATER',
        },
    },
    {
        path: '/cloud-service',
        name: 'CloudService',
        component: CloudService,
        meta: {
            title: '雲原生產品 | BOATWATER',
        },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    next();
    window.scrollTo(0, 0)
});

export default router
